import React from 'react';
import {WorkflowsContext} from '@web/hooks/context';
import {Avatar, Button, InputNumber} from 'antd';
import UserAvatar from '@web/components/UserAvatar';
import Icon from '@web/components/Icon';
import {ServerTimestamp, updatePath} from '@web/lib/firestore.db';
import {notifyAndTrack} from '@web/components/notification';

function Header(props) {
  const wtx = React.useContext(WorkflowsContext);
  const [edit, setEdit] = React.useState(false);
  const [editStepNumber, setEditStepNumber] = React.useState(props.stepNumber);
  const onClickEdit = () => setEdit(!edit);

  const onSaveStepNumber = () => {
    const steps = wtx.workflow.steps?.reduce(($acc, path, index) => {
      if ((index + 1) === editStepNumber) {
        $acc.push(props.path);
        $acc.push(path);
      } else {
        (path !== props.path) && $acc.push(path);
      }
      return $acc;
    }, []);

    updatePath(wtx.workflowPath, {
      steps,
      date: ServerTimestamp(),
    })
    .then(() => notifyAndTrack.success("Nice"))
    .catch((error) => notifyAndTrack.error(error.message));
  }

  return <div className="space space-center-y space-between" style={{margin: "20px 0 40px 0"}}>
    <div className="space space-center-y">
      {edit ?
        <div className="space space-center-y">
          <Button size="large" shape="round" onClick={onSaveStepNumber}><span className="green-color">Save</span></Button>
          <Button size="large" shape="round" onClick={onClickEdit}><span className="green-color">Cancel</span></Button>
        </div>:
        <UserAvatar
          icon={props.icon ? <Icon name={props.icon} /> : null}
          photoURL={props.logo}
        />
      }
      &nbsp;
      <div className="space space-col small">
        <span className="font-xl bolded capitalize">{props.text}</span>
        <label className="muted">{props.subtitle}</label>
      </div>
    </div>
    {props.extra}
    <InputNumber
      size="large"
      max={wtx.workflow?.steps?.length || 1}
      min={1}
      value={editStepNumber}
      onChange={setEditStepNumber}
      onPressEnter={onSaveStepNumber}
    />
  </div>;
}

export default Header;
